import { render, staticRenderFns } from "./AgTable.vue?vue&type=template&id=5935f4a5&"
import script from "./AgTable.vue?vue&type=script&lang=js&"
export * from "./AgTable.vue?vue&type=script&lang=js&"
import style0 from "./AgTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AgTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports